import Helper from './Helper'

export default {
  install: (Vue) => {
    Vue.prototype.$helper = Helper
  }
}